import { render, staticRenderFns } from "./CollectionCaseList.vue?vue&type=template&id=2400d7ec&"
import script from "./CollectionCaseList.vue?vue&type=script&lang=js&"
export * from "./CollectionCaseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports